
















































































import Airport from '@/store/entities/flight/airport';
import AirportTerminal from '@/store/entities/flight/airportTerminal';
import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class AddTerminal extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  airportTerminal: AirportTerminal = new AirportTerminal();
  airports: Airport[] = [];
  airport: Airport = new Airport();

  data() {
    return {
      title: 'Preliminary report',
      email: '',
      rules: {
        required: (value) => !!value || 'Zorunlu Alan.',
        dropdown: (value) => !!value.id || 'Zorunlu Alan.',
      },
    };
  }

  async created() {
    await this.getAirports();

    this.airportTerminal = this.$store.state.airportTerminal.editAirportTerminal;
    if (this.airportTerminal == null) {
      this.isEdit = false;
      this.airportTerminal = new AirportTerminal();
    } else {
      this.airport = this.airports.find(
        (x) => x.id == this.airportTerminal.airportId
      );
      this.isEdit = true;
    }
  }

  async saveAirportTerminal() {
    this.airportTerminal.airportId = this.airport.id;
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: 'airportTerminal/saveAirportTerminal',
        data: this.airportTerminal,
      });

      Vue.$toast.success('Kayıt Eklendi');
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: 'airportTerminal/saveAirportTerminal',
        data: this.airportTerminal,
      });

      Vue.$toast.success('Kayıt Güncellendi');

      this.closeDialog();
    }
  }

  async getAirports() {
    await this.$store.dispatch({
      type: 'airport/getAirports',
    });

    this.airports = this.$store.state.airport.list;
  }

  closeDialog() {
    this.$emit('closed');
  }
  cancelDialog() {
    this.$emit('cancel');
    this.$store.state.airportTerminal.editAirportTerminal = null;
  }
}
